import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'

const locales = { en, es }

export default locales
